
import { Component, Vue } from 'vue-property-decorator'
import {useUserStore} from '@/stores/user'
import { getSubdomain } from '@/utils/subdomain-handler'

import VueQr from 'vue-qr'

@Component({
  name: 'BottomNavigation',
  components: {
    VueQr
  }
})
export default class extends Vue {
  private userStore = useUserStore()

  private QRUrl = window.location.href

  get user(): any {
    return this.userStore.model
  }

  get isBemoveProgram(): any {
    return this.userStore.isBemoveCustomer
  }

  get isVegaCEProgram(): boolean {
    return getSubdomain() === 'vegace'
  }

  get appName(): string {
    if (this.isBemoveProgram) return 'Bemove Avantages'
    if (this.isVegaCEProgram) return 'VegaCE'
    return 'Walleo'
  }

  get appLogo(): string {
    if (this.isVegaCEProgram) return '/img/icons/vegace/icon-128x128.png'
    return this.showWalleoLogo ? this.isBemoveProgram ? require('@/assets/logo/bemove-icon.svg') : require('@/assets/logo/logo-walleo-lite.svg') : ''
  }

  get showWalleoLogo(): boolean {
    return this.userStore.model.program.walleoLogoEnabled
  }
}
